/**
 * 将字符串复制到剪切板
 * @param val {string}
 */
export const copyStr = (str: string): void => {
  const input = document.createElement('input');
  document.body.appendChild(input);
  input.setAttribute('value', str);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
};

/**
 * 判断是不是今天
 * @param timestamp
 */

export const isToday = (time: number) => {
  return new Date().toString().slice(0, 15) === new Date(time).toString().slice(0, 15);
};

export function timePreFix(num: number) {
  return num <= 9 ? `0${num}` : `${num}`;
}

export function formatDate(date: number | Date, format: string) {
  if (typeof date === 'number') {
    date = new Date(String(date).length === 10 ? date * 1000 : date);
  }

  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }

  const timeObj = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  };

  for (const key in timeObj) {
    if (new RegExp(`(${key})`).test(format)) {
      const str = timeObj[<keyof typeof timeObj>key] + '';

      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? str : str.padStart(2, '0'));
    }
  }

  return format;
}

/**
 * 异步加载 JS
 * @param {string} url JS链接
 * @param {string} root JS暴露的全局变量, js标签名
 */
export function scriptLoader(url: string, root: string): Promise<boolean> {
  const complateKey = 'complate';
  return new Promise(resolve => {
    const body = document.querySelector('body');
    let s = document.getElementById(root) as HTMLScriptElement;
    if (!s || !(s instanceof HTMLScriptElement)) {
      s = document.createElement('script');
      s.type = 'text/javascript';
      s.id = root;
      s.src = url;
      body && body.appendChild(s);
    }

    s.addEventListener('load', () => {
      console.log(`${root} script load complate!`);
      s.setAttribute(complateKey, '1');

      resolve(true);
    });
    s.addEventListener('error', () => {
      body?.removeChild(s);
      resolve(false);
    });
    s.getAttribute(complateKey) && resolve(true);
  });
}

export const onlyRunInNotBot = (func: () => any, catchErr = true) => {
  const robots = [
    'googlebot',
    'applebot',
    'bingbot',
    'duckDuckbot',
    'naverbot',
    'twitterbot',
    'yandex',
    'facebot',
    'facebookexternalhit',
    'facebookcatalog',
    'serpstatbot',
    'ahrefsbot',
    'ahrefssiteaudit',
  ];

  const isCrawler = robots.some(bot => {
    return navigator.userAgent.toLowerCase().includes(bot);
  });

  if (!isCrawler) {
    try {
      func();
    } catch (e) {
      if (catchErr) {
        // do nothing.
      } else {
        throw e;
      }
    }
  }
};

export function generateRandom() {
  return Math.random().toString(16).slice(2);
}

// 获取url地址的文件名称
export function getUrlName(url?: string) {
  if (!url) {
    return '';
  }
  return url.match(/([^/]+)\.\w+$/)?.[1];
}
